"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var buttonSubmitStyles_1 = require("./buttonSubmitStyles");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var JourneyTypes_1 = require("../../../../../../../common/enum/JourneyTypes");
var ButtonSubmit = function (_a) {
    var disabled = _a.disabled, journeyType = _a.journeyType;
    var _b;
    var getButtonTranslationID = function (journeyType) {
        if (journeyType === JourneyTypes_1.JourneyTypes.CONTINUE_IN_DEALERSHIP) {
            return 'trans__checkout__enquiry_form__submit_button';
        }
        else if (journeyType === JourneyTypes_1.JourneyTypes.ORDER_ONLINE) {
            return 'trans__checkout__next_step__continue_CTA';
        }
        return 'trans__checkout__enquiry_form__reserve_submit_button';
    };
    var translationId = react_1.useMemo(function () { return getButtonTranslationID(journeyType); }, [journeyType]);
    var styles = buttonSubmitStyles_1.default();
    var checkout4 = core_1.useTheme().checkoutLite.checkout4;
    return (<core_1.Box className={styles.submitButtonContainer}>
      <core_1.Button type="submit" disabled={disabled} className={styles.submitButton} classes={{ contained: styles.btnContained, containedPrimary: styles.newContainedPrimary }} variant="contained" color="primary" data-test="button:enquiry_form:submit" disableTouchRipple={!!((_b = checkout4) === null || _b === void 0 ? void 0 : _b.disableTouchRipple)}>
        <Translation_1.default id={translationId}/>
      </core_1.Button>
    </core_1.Box>);
};
exports.default = ButtonSubmit;
